export default "__VITE_ASSET__CzCdD$Vs__"